import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { Link } from 'react-router-dom';
import { formatDate, formatCurrency, formatTime } from '../../utils/helper';
import { toast } from 'react-toastify';
import { getAppointmentStatus } from '../../utils/statusHelper';

const List = () => {
    const [isLoader, setIsLoader] = useState(false);
    const [visits, setVisits] = useState([]);
    const [pagination, setPagination] = useState({});
    const [apiData, setApiData] = useState({
        search: "",
        page: 1,
    });

    useEffect(() => {
        getVisits();
    }, [apiData.page, apiData.search]); 

    const getVisits = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "admin/specialist-visits", 
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setVisits(data.data.visits || []); 
                setPagination(data.data.pagination || {});
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoader(false);
        }
    };

    const deleteVisit = async (id) => {
        if (!window.confirm("Are you sure you want to delete this visit?")) return;
        
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "DELETE",
                url: `admin/specialist-visits/${id}`,
            });
            if (response.data.status) {
                toast.success(response.data.message);
                getVisits();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "Something went wrong");
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            Specialist Visits
                        </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <OverlayTrigger placement="top" overlay={<Tooltip>Create Visit</Tooltip>}>
                            <Link to="/specialist-visits/create" className="btn btn-sm fw-bold btn-base">
                                Create Visit
                            </Link>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                         <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <div className="d-flex align-items-center position-relative my-1">
                                    <span className="svg-icon svg-icon-1 position-absolute ms-6">
                                        <i className="fas fa-search fs-1"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control form-control-solid w-250px ps-14"
                                        placeholder="Search Specialist"
                                        value={apiData.search}
                                        onChange={(e) => setApiData({ ...apiData, search: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body py-4">
                            {isLoader ? (
                                <Loader />
                            ) : (
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                <th className="min-w-125px">Date</th>
                                                <th className="min-w-125px">Time</th>
                                                <th className="min-w-125px">Specialist</th>
                                                <th className="min-w-125px">Clinic Fee</th>
                                                <th className="text-end min-w-100px">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold">
                                            {visits.map((visit, index) => (
                                                <tr key={index}>
                                                    <td>{formatDate(visit.visit_date)}</td>
                                                    <td>{formatTime(visit.visit_time_from)} - {formatTime(visit.visit_time_to)}</td>
                                                    <td>{visit.specialist?.name}</td>
                                                    <td>{formatCurrency(visit.clinic_fee)}</td>
                                                    <td className="text-end">
                                                        <Link to={`/specialist-visits/${visit.id}`} className="btn btn-icon btn-light btn-active-light-primary btn-sm me-2" title="Details">
                                                            <i className="fas fa-eye"></i>
                                                        </Link>
                                                        <Link to={`/specialist-visits/edit/${visit.id}`} className="btn btn-icon btn-light btn-active-light-primary btn-sm me-2" title="Edit">
                                                            <i className="fas fa-edit"></i>
                                                        </Link>
                                                        <button onClick={() => deleteVisit(visit.id)} className="btn btn-icon btn-light btn-active-light-danger btn-sm" title="Delete">
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {visits.length === 0 && (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No visits found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            <Paginator pagination={pagination} onPageChange={(page) => setApiData({ ...apiData, page })} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
